module.exports = __webpack_public_path__ + "static/flags/DR-8bc08047833ec592d9752283c9c232cb.gif";